<template>
  <div>
    <div v-if="!banks || !banks.length" class="row">
      <div class="col">
        <div class="alert alert-info">لا توجد حسابات بنكية مضافة من قبل المزود</div>
      </div>
    </div>
    <div v-else class="table-responsive">
      <table class="table table-striped align-middle">
        <thead>
          <tr>
            <th>#</th>
            <th>اسم صاحب الحساب</th>
            <th>البنك</th>
            <th>IBAN</th>
            <th>العنوان 1</th>
            <th>العنوان 2</th>
            <th>تاريخ الإضافة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="bank in banks" :key="bank.id">
            <td>{{ bank.id }}</td>
            <td>{{ bank.name || '—' }}</td>
            <td>
              <span v-if="bank.BankAccount">{{ bank.BankAccount.name }}</span>
              <span v-else class="text-muted">—</span>
            </td>
            <td>
              <span class="user-select-all" dir="ltr">{{ bank.iban || '—' }}</span>
              <button
                v-if="bank.iban"
                type="button"
                class="btn btn-light btn-sm ms-2"
                title="نسخ iban"
                @click="copyIban(bank.iban)"
              ><i class="bi bi-clipboard"></i></button>
            </td>
            <td>{{ bank.address1 || '—' }}</td>
            <td>{{ bank.address2 || '—' }}</td>
            <td>{{ (bank.createdAt)? bank.createdAt.split('T')[0] : '—' }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="copied" class="text-success small"><i class="bi bi-check2"></i> تم نسخ IBAN</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProviderBanks',
  props: {
    banks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    copyIban(iban) {
      navigator.clipboard.writeText(iban).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      });
    },
  },
};
</script>